import '../index.css';
import React from 'react';
import CardGroup from 'react-bootstrap/CardGroup';
import Card from 'react-bootstrap/Card';
import {  HorizontalTicker } from "react-infinite-ticker";
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';

function GainsTicker() {

    return(
        
       
        
                <HorizontalTicker duration={40000} delay={0}>
                        <CardGroup className='resultPair rounded shadow' >
                            <Row>
                                <Col>
                                    <Card style={{backgroundColor: "black", color:"black"}}>
                                        <Card.Img className='img-fluid' src="img/ashtonbefore.webp" variant="top"  />
                                        <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>Before</Card.Title>
                                    </Card.ImgOverlay>
                                    </Card>
                                </Col>
                                <Col>
                                    <Card style={{backgroundColor: "black", color:"black"}}>
                                        <Card.Img className='img-fluid' src="img/ashtonafter.webp" variant="top"  />
                                        <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>After</Card.Title>
                                    </Card.ImgOverlay>
                                    </Card>
                                </Col>
                            </Row>
                        </CardGroup>
                        <CardGroup className='resultPair rounded shadow' >
                            <Row>

                            <Col>
                                <Card style={{backgroundColor: "black"}}>
                                    <Card.Img className='img-fluid' src="img/gagebefore.webp" variant="top" />
                                    <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>Before</Card.Title>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            <Col>
                                <Card style={{backgroundColor: "black"}}>
                                    <Card.Img className='img-fluid' src="img/gageafter.webp" variant="top" />
                                    <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>After</Card.Title>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            </Row>
                        </CardGroup>
                        <CardGroup className='resultPair rounded shadow' >
                            <Row>

                            <Col>
                                <Card style={{backgroundColor: "black"}}>
                                    <Card.Img className='img-fluid' src="img/zoeybefore.webp" variant="top"  />
                                    <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>Before</Card.Title>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            <Col>
                                <Card style={{backgroundColor: "black"}}>
                                    <Card.Img className='img-fluid' src="img/zoeyafter.webp" variant="top"  />
                                    <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>After</Card.Title>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            </Row>
                        </CardGroup>
                        <CardGroup className='resultPair rounded shadow' >
                            <Row>

                            <Col>
                                <Card style={{backgroundColor: "black"}}>
                                    <Card.Img className='img-fluid' src="img/jeremybefore.webp" variant="top" />
                                    <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>Before</Card.Title>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            <Col>
                                <Card style={{backgroundColor: "black"}}>
                                    <Card.Img className='img-fluid' src="img/Jeremyafter.webp" variant="top" />
                                    <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>After</Card.Title>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            </Row>
                        </CardGroup>
                        <CardGroup className='resultPair rounded shadow' >
                            <Row>
                                
                            <Col>
                                <Card style={{backgroundColor: "black"}}>
                                    <Card.Img className='img-fluid' src="img/Madisonbefore.jpg" variant="top"  />
                                    <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>Before</Card.Title>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            <Col>
                                <Card style={{backgroundColor: "black"}}>
                                    <Card.Img className='img-fluid ' src="img/Madisonafter.webp" variant="top"  />
                                    <Card.ImgOverlay>
                                        <Card.Title style={{color:"white"}}>After</Card.Title>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            </Row>
                        </CardGroup>
                        
                    
                </HorizontalTicker>
             
    );
}

export default GainsTicker;